// @ts-nocheck
<template>
  <div class="loginBox">
    <img alt="logo" class="ciic" src="../../assets/photo/ciic.png">
    <div class="menban"></div>
    <div class="hi">您好！
      <br>
      欢迎进入外籍雇员管理系统
    </div>
    <div class="hiWelcome">Hi, Welcome to the work hours management system</div>
    <div class="allcode">
      <div class="first">
        <span class="title">登录</span>
      </div>
      <div class="contentBox">
        <div class="contentName">
        </div>
        <div v-show="register">
          <div class="contentInput">
            <input v-model.trim="getData.telephone" placeholder="请输入账号" type="text">
            <Icon class="telIcon" type="ios-person-outline"/>
            <form onsubmit="return false" style="margin-top: 20px;">
              <input v-model.trim="getData.password" :placeholder="placeholder" autocomplete="on" class="secInput"
                     type="password" @blur="myBlur()" @focus="myFocus()">
              <Icon class="passwordIcon" style="margin-top: 20px;" type="ios-unlock-outline"/>
            </form>
          </div>
          <div class="logBtn">
            <Button :disabled="loginLoading" :loading="loginLoading" class="btn" style="width: 100%" type="success"
                    @click="goHome('code')">{{ loginLoading ? '登录中...' : '登录' }}
            </Button>
          </div>
        </div>
        <div v-show="noRegister">
          <div class="contentInput">
            <input v-model.trim="getNumData.telephone" placeholder="请输入11位手机号" style="margin-bottom: 10px;"
                   type="text">
            <Icon class="telIcon" type="ios-person-outline"/>
            <div>
              <input v-model.trim="getNumData.password" class="newInput" placeholder="请输入动态密码" type="text">
              <Icon class="passwordIcon" type="ios-unlock-outline"/>
              <button :class="codeDisabled?'noBtu':'newBtu'" :disabled="codeDisabled" @click="goCode">{{
                  getCode
                }}
              </button>
            </div>
          </div>
          <div class="logBtn">
            <Button :disabled="disGohome" :loading="disGohome" class="btn"
                    @click="goHome('tel')">{{ disGohome ? '登录中...' : '登录' }}
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p style="font-size: 14px;color:#fff">技术支持：浙江中智经济技术服务有限公司 Copyright©2023</p>
    </div>
    <registerModal v-if="showModal" :createLoading='createLoading' @closeModal='showModal=false'
                   @commitModal='commitModal'></registerModal>
  </div>
</template>

<script>
import {login, loginCaptcha} from '@/api/login.js'
import {licenseGenerate, sendCaptcha} from '@/api/public.js'
import registerModal from '@/views/component/registerModal.vue'

export default {
  name: 'login',
  components: {
    registerModal
  },
  data() {
    return {
      loginLoading: false,
      placeholder: '请输入密码', // 绑定input
      getInputClass: true, // 控制登陆方式
      register: true, // 控制登陆方式显示内容
      noRegister: false, // 控制登陆方式显示内容
      countdown: '60',
      getCode: '获取动态密码',
      codeDisabled: false, // 控制按钮disabled
      getData: {
        tel: '',
        password: ''
      },
      getNumData: {
        tel: '',
        password: ''
      },
      showModal: false,
      createLoading: false,
      disGohome: false // 控制登录disabled
    }
  },
  created() {
  },
  mounted() {
    let _self = this
    document.onkeydown = function () {
      let key = window.event.keyCode
      if (key === 13) {
        if (!_self.getNumData.password && _self.$route.name === 'login') {
          _self.goHome('code')
        } else if (_self.getNumData.password && _self.$route.name === 'login') {
          _self.goHome('tel')
        }
      }
    }
  },
  methods: {
    // 密码获取焦点
    myFocus() {
      this.placeholder = '8-12位，大小写字母、数字、特殊符号'
    },
    // 密码失去焦点
    myBlur() {
      this.placeholder = '请输入密码'
    },
    // 变换登陆方式
    chengRegistere(val) {
      if (val === 'code') {
        this.getNumData = {}
        this.getInputClass = true
        this.noRegister = false
        this.register = true
      } else if (val === 'tel') {
        this.getData = {}
        this.getInputClass = false
        this.register = false
        this.noRegister = true
      }
    },
    // 调取短信接口
    goCode() {
      let myreg = /^1[3456789]\d{9}$/
      if (myreg.test(this.getNumData.telephone)) {
        sendCaptcha(this.getNumData.telephone).then(() => {
        })
        this.setTime()
      } else {
        this.$Message.error('手机号码格式不正确')
      }
    },
    // 获取动态密码
    setTime() {
      if (this.countdown === 0) {
        this.codeDisabled = false
        this.getCode = '获取验证码'
        this.countdown = 60
        return
      }
      this.codeDisabled = true
      this.getCode = '(' + this.countdown + ')'
      this.countdown--

      setTimeout(() => {
        this.setTime()
      }, 1000)
    },
    // 登录跳转
    goRegiste() {
      this.$router.push({name: 'register'})
    },
    goForgotPassword() {
      this.$router.push({name: 'forgetPassword'})
    },
    goHome(val) {
      this.loginLoading = true
      if (val === 'code') {
        let passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,20}$/;
        if (
          this.getData.telephone === '' ||
          this.getData.password === '' ||
          !this.getData.telephone ||
          !this.getData.password
        ) {
          this.$Message.error('账号和密码不能为空！')
          setTimeout(() => {
            this.loginLoading = false
          }, 1000)
        } else if (passwordReg.test(this.getData.password)) {
          login({
            adminCode: this.getData.telephone,
            password: this.getData.password
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.loginLoading = false
            } else {
              localStorage.setItem('getToken', response.data.data)
              /*licenseCheck().then(res => {
                this.loginLoading = false
                if (res.data.code === 401){
                  localStorage.removeItem('getToken')
                }
                if (res.data.success === false) {
                  this.showModal = true
                  this.$Message.warning(res.data.msg)
                } else {
                  this.$router.push({ name: 'homeContent' })
                }
              })*/
              this.$router.push({name: 'homeContent'})
            }
          }).catch(() => {
            this.loginLoading = false
          })
        } else {
          this.$Message.error('密码不符合规范')
          this.loginLoading = false
        }
      } else if (val === 'tel') {
        if (
          this.getNumData.telephone === '' ||
          this.getNumData.password === '' ||
          !this.getNumData.telephone ||
          !this.getNumData.password
        ) {
          this.$Message.error('手机号和验证码不能为空')
          setTimeout(() => {
            this.loginLoading = false
          }, 1000)
        } else {
          loginCaptcha({
            telephone: this.getNumData.telephone,
            captcha: this.getNumData.password
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.loginLoading = false
            } else {
              this.loginLoading = false
              localStorage.setItem('getToken', response.data.data)
              this.$router.push({name: 'homeContent'})
            }
          }).catch(() => {
            this.loginLoading = false
          })
        }
      }
    },
    // 生存注册申请
    commitModal(val) {
      this.createLoading = true
      licenseGenerate(val).then(res => {
        this.createLoading = false
        const link = document.createElement('a')
        let blob = new Blob([res.data], {type: 'text/plain'})
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = '注册申请文件.txt' // 下载的文件名
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(() => {
        this.$Message.error('生成失败')
        this.createLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.loginBox {
  width: 100%;
  height: 100%;
  background-image: url("~@/assets/photo/ciic.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;

  .hi {
    position: absolute;
    left: 129px;
    top: 320px;
    width: 873px;
    height: 212px;
    color: rgba(255, 255, 255, 1);
    font-size: 72px;
    text-align: left;
    background-color: rgba(255, 255, 255, 0);
  }

  .hiWelcome {
    position: absolute;
    left: 125px;
    top: 543px;
    width: 873px;
    height: 89px;
    color: rgba(255, 255, 255, 1);
    font-size: 28px;
    text-align: left;
  }

  .ciic {
    position: absolute;
    left: 56px;
    top: 25px;
    width: 120px;
    height: 120px;
  }

  .menban {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 63, 144, 0.5);
  }

  .allcode {
    background-color: #fff;
    position: absolute;
    top: 15%;
    left: 65%;
    width: 500px;
    height: 600px;
    line-height: 20px;
    border-radius: 8px;

    .first {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 80px;

      .title {
        font-size: 36px;
        font-weight: 600;
        color: rgba(37, 117, 255, 1);
      }
    }

    .contentBox {
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      width: 460px;
      height: 330px;
      margin: 0 auto;

      .contentName {
        padding-top: 47px;
        padding-left: 37px;

        .register {
          font-size: 20px;
          font-weight: bold;
          border-bottom: 3px solid rgba(91, 205, 174, 1);
          border-radius: 1px;
          padding: 6.4px 25px;
          cursor: pointer;
        }

        .noRegister {
          font-size: 20px;
          padding: 6.4px 25px;
          cursor: pointer;
        }

        .hello {
          font-size: 24px;
          padding: 6.4px 25px;
          font-weight: 600;
          text-align: center;
          width: 150px;
          margin-left: 120px;
          height: 40px;
          line-height: 40px;
        }

        .hello::after {
          content: '';
          width: 80%;
          height: 1px;
          display: block;
          margin: 0 auto;
          border-bottom: 2px solid #3A62D7;
          padding: 1px;
        }
      }
    }

    .contentInput {
      position: relative;

      .telIcon {
        font-size: 24px;
        position: absolute;
        top: 45px;
        left: 50px;
      }

      .newInput {
        width: 276px;
        margin-top: 16px;
      }

      input {
        width: 386px;
        height: 52px;
        margin-top: 32px;
        margin-left: 37px;
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 5px;
        text-indent: 50px;
        font-size: 16px;
      }

      .secInput {
        margin-top: 16px;
      }

      .newBtu {
        width: 100px;
        height: 52px;
        background: rgba(91, 205, 174, 1);
        border-radius: 6px;
        border: 0;
        color: white;
        margin-left: 10px;
        outline: none;
        cursor: pointer;
        font-size: 15px;
      }

      .noBtu {
        width: 100px;
        height: 52px;
        background: rgba(221, 221, 221, 1);
        border-radius: 6px;
        border: 0;
        color: black;
        margin-left: 10px;
        outline: none;
        font-size: 15px;
      }

      .passwordIcon {
        font-size: 24px;
        position: absolute;
        top: 114px;
        left: 50px;
      }

      input:focus {
        border-style: solid;
        border-color: #4cd4a6;
        outline: none;
      }
    }

    .logBtn {
      .btn {
        width: 450px;
        height: 50px;
        line-height: 23px;
        border-radius: 10px;
        background-color: rgba(37, 117, 255, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        text-align: center;
      }

      margin: 80px 37px 0 37px;
    }
  }

  .footer {
    width: 100%;
    position: absolute;
    bottom: 21px;
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    color: #fff;
    // font-weight: bold;
    a {
      cursor: pointer;
      color: #fff;
    }
  }

  .btns {
    font-size: 14px;
    color: #000;
    display: flex;
    flex-direction: row;
    margin: 32px 37px 0 37px;
    padding-left: 120px;
    padding-right: 120px;
    justify-content: space-between;

    p {
      cursor: pointer;
    }

    .btnsright {
      color: rgba(58, 98, 215, 1);

    }
  }
}
</style>
